<template>
    <modal :show="show" class="modal-add-unit">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Change Status</modal-header>
        </div>
        <div class="form-group">
          <p>Do You Want To Change Status From Queued To Edited ? </p>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" cancelText="No" :confirm="confirm" confirmText="Yes" :confirmDisabled="false"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'model-change-status-prompt',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    creativeId: String
  },
  data: () => ({
    choices: {
      masterChosen: null,
      locale: null,
      width: null,
      height: null,
      render_video_duration: 8,
      render_video_fps: 15,
      render_video_format: 'mp4'
    }
  }),
  methods: {
    close () {
      this.$emit('close')
    },
    confirm () {
      this.startLoading()
      this.updateCreativeUnitStatus(this.confirmId).then(() => {
        this.getCreativeUnits(this.creativeId).then(() => {
          this.finishLoading()
          this.$emit('confirm')
        })
      })
      this.$emit('close')
    }
  }
}

</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/model-change-status-prompt.vue